/** IDs canônicos usados no site (checkout, pricing). */

const PLAN_LABELS = {

  gratuito: 'Gratuito',

  basico: 'Básico',

  pro: 'Pro',

  enterprise: 'Empresarial',

}



/** Valores em `users/{uid}/profile/subscriptionPlan` (produção). */

const PRODUCTION_ALIASES = {

  free: 'gratuito',

  gratuito: 'gratuito',

  basic: 'basico',

  basico: 'basico',

  pro: 'pro',

  enterprise: 'enterprise',

}



/** Meses cobrados no plano anual (fonte única de preço). */

export const ANNUAL_PAID_MONTHS = 10



/** Meses de acesso incluídos no plano anual. */

export const ANNUAL_ACCESS_MONTHS = 12



/** Dias de antecedência do aviso de renovação automática (cartão). */

export const RENEWAL_NOTICE_DAYS = 7



/** Avisos de encerramento do plano anual PIX (sem renovação automática). */

export const EXPIRY_NOTICE_DAYS = [5, 3]



export const ANNUAL_MARKETING_TAGLINE = 'Pague 10 meses e use por 12 meses.'



export const ANNUAL_CHECKOUT_TERMS =

  'Ao continuar com o pagamento, você confirma que está contratando o plano anual com cobrança equivalente a 10 meses e acesso válido por 12 meses. A renovação será automática no cartão de crédito cadastrado, com aviso prévio enviado por e-mail antes da cobrança.'



export const ANNUAL_PIX_CHECKOUT_TERMS =

  'Ao continuar, você contrata o plano anual via PIX com acesso por 12 meses. Não há renovação automática: enviaremos avisos por e-mail 5 e 3 dias antes do encerramento e, ao término, seu plano volta ao Gratuito. Para manter os benefícios, renove manualmente.'



export function addMonthsIso(isoDate, months) {

  const d = new Date(`${isoDate}T12:00:00Z`)

  d.setUTCMonth(d.getUTCMonth() + months)

  return d.toISOString().slice(0, 10)

}



/** Valores mensais — altere aqui; o anual é derivado automaticamente. */

export const PLAN_MONTHLY_AMOUNTS = {

  basico: 19.9,

  pro: 59.9,

}



export function getSubscriptionPlanFromUser(userNode) {

  if (!userNode) return null

  return userNode?.profile?.subscriptionPlan ?? userNode?.subscriptionPlan ?? null

}



export function normalizePlanId(raw) {

  if (!raw) return null

  const key = String(raw).toLowerCase()

  return PRODUCTION_ALIASES[key] || key

}



/** Grava no RTDB de produção (`profile.subscriptionPlan`). */

export function toProductionSubscriptionPlan(webPlanId) {

  const normalized = normalizePlanId(webPlanId)

  if (normalized === 'basico') return 'basic'

  if (normalized === 'gratuito') return 'gratuito'

  return normalized

}



export function planDisplayName(planId) {

  const normalized = normalizePlanId(planId)

  if (!normalized) return null

  return PLAN_LABELS[normalized] || normalized

}



export function getMonthlyAmount(planId) {

  const id = normalizePlanId(planId)

  return PLAN_MONTHLY_AMOUNTS[id] ?? 0

}



/** Total anual cobrado = mensal × 10 meses. */

export function getAnnualTotal(planId) {

  const monthly = getMonthlyAmount(planId)

  if (!monthly) return 0

  return Math.round(monthly * ANNUAL_PAID_MONTHS * 100) / 100

}



export const ANNUAL_MAX_INSTALLMENTS = 12



/** Valor de cada parcela (exibição; a última pode diferir em centavos no Asaas). */

export function getInstallmentValue(total, count) {

  if (!count || count < 2) return total

  const cents = Math.round(total * 100)

  return Math.floor(cents / count) / 100

}

export function getCheckoutAmount(planId, billingCycle) {

  const cycle = String(billingCycle || 'monthly').toLowerCase()

  return cycle === 'annual' ? getAnnualTotal(planId) : getMonthlyAmount(planId)

}



export function formatPlanCurrency(amount) {

  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(amount)

}



export function isPaidPlan(planId) {

  return getMonthlyAmount(planId) > 0

}



/** Limites por plano — o app mobile usa `profile.subscriptionPlan` para aplicar estes recursos. */

export const PLAN_LIMITS = {

  gratuito: { maxDevices: 1, historyDays: 30, guestUsers: 0, weeklyReport: false, remoteControl: false },

  basico: { maxDevices: 2, historyDays: 90, guestUsers: 1, weeklyReport: true, remoteControl: false },

  pro: { maxDevices: 5, historyDays: 365, guestUsers: 5, weeklyReport: true, remoteControl: true },

}



/** Combina plano do perfil (produção) com metadados de cobrança Asaas (`planos/{uid}`). */

export function buildPlanFromSources({ userNode, billing }) {

  const raw = getSubscriptionPlanFromUser(userNode)

  const fromProfile = normalizePlanId(raw)

  const fromBilling = normalizePlanId(billing?.planId)

  const pendingPlanId = normalizePlanId(billing?.pendingPlanId)

  const planActivated = billing?.planActivated === true



  const activeFromBilling = planActivated && fromBilling ? fromBilling : null

  const planId = fromProfile || activeFromBilling

  if (!planId && !billing) return null



  if (planId === 'gratuito') {

    return {

      planId: 'gratuito',

      planName: planDisplayName('gratuito'),

      subscriptionPlan: raw,

      planActivated: false,

      pendingPlanId: null,

      pendingPlanName: null,

    }

  }



  return {

    ...billing,

    planId,

    planName: planDisplayName(planId) || billing?.planName || null,

    subscriptionPlan: raw,

    pendingPlanId: !planActivated && pendingPlanId ? pendingPlanId : null,

    pendingPlanName:

      !planActivated && pendingPlanId

        ? billing?.pendingPlanName || planDisplayName(pendingPlanId)

        : null,

    planActivated: planActivated === true,

  }

}


